// extracted by mini-css-extract-plugin
module.exports = {"exchangeTypeWrapper":"ExchangeRadio_exchangeTypeWrapper__3--Ra","exchangeTitle":"ExchangeRadio_exchangeTitle__YjxbS"};